import "./App.css";
import Board from "./components/Board";
import { Container } from "react-bootstrap";

function App() {
  return (
    <Container className="App">
      <Board />
    </Container>
  );
}

export default App;
